import { createSelector } from 'reselect'

import iconTypes from 'helpers/enums/iconTypes'

const processingSelector = state => state.processing

const pendingIconsSelector = createSelector(
	[ processingSelector ],
	processingState => {
		const iconsFiltered = processingState.icons.filter(icon => (
			icon.status !== iconTypes.ICON_STATUS_DONE
				||	icon.status !== iconTypes.ICON_STATUS_ERROR
		))
		const iconIds = iconsFiltered.map(icon => icon.id)
		return {
			icons: iconIds,
		}
	}
)

export default pendingIconsSelector
